module.exports = __webpack_public_path__ + "img/footer-background.ec5b02a1.png";